import { render, staticRenderFns } from "./carriers.vue?vue&type=template&id=3a897839&"
import script from "./carriers.vue?vue&type=script&lang=js&"
export * from "./carriers.vue?vue&type=script&lang=js&"
import style0 from "./carriers.vue?vue&type=style&index=0&id=3a897839&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports